<template>
  <div class="modal fade" id="add-temp-tunnel" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <LoadingElement v-if="loading" />
      <div class="modal-content">
        <div class="modal-body" v-if="!selectedNas.tunnel">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-temp-tunnel-close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-primary">
              {{ $t("nases.generate_remote_tunnel") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />
          <div class="row">
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("tunnels.nas")
              }}</label>
              <input
                type="text"
                class="form-control"
                :disabled="selectedNas.id"
                :value="selectedNas.name"
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("tunnels.port_to_forward")
              }}</label>
              <select class="form-select" v-model="tunnel.select_port">
                <option value="80">HTTP (80)</option>
                <option value="443">HTTPS (443)</option>
                <option value="8291">Winbox (8291)</option>
                <option value="-1">{{ $t("tunnels.custom_input") }}</option>
              </select>
              <input
                type="number"
                min="10"
                max="65535"
                v-if="tunnel.select_port === '-1'"
                v-model="tunnel.internal_port"
                class="form-control"
                placeholder="10-65535"
              />
            </div>
            <div
              class="col-12 text-danger"
              v-for="(item, index) in server_errors"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="row mt-4">
            <div class="flex justify-center">
              <button
                class="btn btn-primary"
                :disabled="
                  loading ||
                    tunnel.internal_port > 65535 ||
                    tunnel.internal_port < 10
                "
                @click="store"
              >
                {{ $t("tunnels.generate_tunnel") }}
              </button>
            </div>
          </div>
        </div>
        <div v-else class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-temp-tunnel-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-2 text-secondary">
              {{ $t("nases.remote_tunnel") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />
          <div class="flex justify-center my-4">
            <div class="input-group">
              <button
                @click="goToUrl(selectedNas.tunnel.url)"
                v-if="selectedNas.tunnel.is_url"
                class="btn btn-primary"
              >
                {{ $t("tunnels.go_to_url") }}
              </button>
              <button
                @click="copyToClipboard(selectedNas.tunnel.url)"
                v-else
                class="btn btn-primary"
              >
                <i class="ti ti-clipboard"></i>
              </button>
              <input
                type="text"
                class="form-control text-center"
                :value="selectedNas.tunnel.url"
              />
            </div>
          </div>
          <div class="flex justify-center">
            <button class="btn btn-danger" @click="remove">
              {{ $t("tunnels.remove_tunnel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "TunnelAddModal",
  props: {
    nas: {
      type: Object,
      required: false,
    },
    networkdevice: {
      type: Object,
      required: false,
    },
  },
  created() {
    if (this.nas) {
      this.selectedNas = this.nas;
    }
    if (this.networkdevice) {
      this.selectedNetworkDevice = this.nas;
    }
  },
  data() {
    return {
      loading: false,
      selectedNas: {
        id: null,
      },
      selectedNetworkDevice: {
        ip: null,
      },
      tunnel: {
        select_port: "80",
        internal_port: 80,
      },
      server_errors: null,
    };
  },
  methods: {
    async store() {
      try {
        if (this.selectedNas.id != null) {
          const response = await axios.post("nases/tunnel", {
            nas_id: this.selectedNas.id,
            device_port:
              this.tunnel.select_port === "-1"
                ? this.tunnel.internal_port
                : this.tunnel.select_port,
          });
          if (response.status === 200) {
            document.getElementById("add-temp-tunnel-close").click();
            this.$notify({
              text: this.$t("tunnels.tunnel_generated_successfully"),
              type: "success",
            });
            this.$emit("updated");
          } else if (response.status == 210) {
            this.$notify({
              text: this.$t("tunnels.tunnel_generate_failed"),
              type: "error",
            });
            this.server_errors = response.data.errors;
            this.validated = false;
          }
        }
      } catch (error) {
        this.$notify({
          text: this.$t("tunnels.tunnel_generate_failed"),
          type: "error",
        });
      }
    },

    async remove() {
      if (this.selectedNas.id != null) {
        const response = await axios.post("nases/tunnel/remove", {
          tunnel_id: this.selectedNas.tunnel.id,
        });
        if (response.status === 200) {
          document.getElementById("add-temp-tunnel-close").click();
          this.$notify({
            text: this.$t("tunnels.tunnel_removed_successfully"),
            type: "success",
          });
          this.$emit("updated");
        }
      } else {
        this.$notify({
          text: this.$t("tunnels.tunnel_remove_failed"),
          type: "error",
        });
      }
    },
    goToUrl(url) {
      console.log(url);

      window.open(url, "_blank").focus();
    },
    copyToClipboard(url) {
      // Get the text field
      var copyText = document.createElement("textarea");
      copyText.value = url;
      document.body.appendChild(copyText);
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
  },
};
</script>
